// extracted by mini-css-extract-plugin
export default {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","main":"g2IK1","brandValue":"c4VPH"};